import { DatePipe } from '@angular/common'
import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'

import * as state from '../../../../../../../state'
import * as stores from '../stores'
/**
 * List of notes in Summit Archive
 */
@ngCore.Component({
  imports: [
    ds.loader.Component,
    ds.illustration.emptyState.Component,
    ds.stripHtml.Pipe,
    DatePipe,
  ],
  selector: 'atn-summit-archive-catalog',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.summit.archive.Collection}  */
  public readonly archiveEc = ngCore.inject(state.summit.archive.Collection)
  /** @see {@link stores.AiAssistantOrchestrator} */
  private readonly _assistantOrchestrator = ngCore.inject(
    stores.AiAssistantOrchestrator,
  )

  /** A unified collection that merges user creations with loaded archive items */
  public readonly itemsAndCreations =
    this.archiveEc.plugins.currentListPlugin.feature.selectors.entities.project(
      this.archiveEc.plugins.editingPlugin.feature.selectors.creationsLookup.project(
        lookup =>
          Object.entries(lookup).map(([id, creation]) => ({ id, ...creation })),
      ).asSelector,
      (items, creations) => [...creations, ...items],
    )

  public onSelectItemHandler(item: ListItem<typeof this.itemsAndCreations>) {
    this.archiveEc.plugins.currentEntityPlugin.storage.actions.putInIdLookup
      .from('Summit.Active.Catalog.Item.Clicked')
      .dispatch({ value: item.id })
    const assistant = this._assistantOrchestrator.assistantSg()
    if (!assistant) {
      return
    }
    // TODO: should be moved to effect
    assistant.actions.reset
      .from('Summit.Active.Catalog.Item.Clicked')
      .dispatch()
  }

  public onDeleteItemHandler(item: ListItem<typeof this.itemsAndCreations>) {
    const source = 'Summit.Active.Catalog.Item.Delete.Clicked'
    if (ec.plugins.standard.editing.models.CreationId.isCreationId(item.id)) {
      this.archiveEc.plugins.editingPlugin.feature.actions.discard
        .from(source)
        .dispatch({ create: [item.id] })
    } else {
      this.archiveEc.plugins.editingPlugin.feature.actions.markForDeletion
        .from(source)
        .dispatch({ id: item.id })
    }
  }
}

type ListItem<T> =
  T extends store.selectors.BoundSelector<infer TSelector>
    ? TSelector extends readonly (infer TArrayItem)[]
      ? TArrayItem
      : never
    : never
